import React from "react";
import AppointmentItem from "./appointment";
import { useQuery } from "@apollo/client";
import { useLocation } from 'react-router-dom';
import { GET_APPOINTMENT } from "queries/queries";
import Loading from "components/loading";
import Error from "components/error";
import { useHistory } from "react-router-dom";
import backArrow from '../../assets/images/left_arrow.png';

const AppointmentDetail = ({ }) => {
  const location = useLocation();
  const { appointmentId } = location.state || {};
  const history = useHistory();

  const appointmentDetails = useQuery(GET_APPOINTMENT, {
    variables:  {appointmentId} ,
    fetchPolicy: "no-cache",
  })

  if (appointmentDetails.loading) return <Loading />;
  if (appointmentDetails.error) return <Error />;

  const appointment = appointmentDetails.data.getAppointment;

  const handleBack = () => {
    history.goBack() 
  };

  return (
    <div className="appointment-details">
      <img 
        src={backArrow} 
        alt="back" 
        className="points-header-arrow" 
        onClick={handleBack} 
      />
      <div>Dein nächster Termin</div>
      <AppointmentItem
        next={true}
        arrow={''}
        project={appointment}
      />
      <div className="appointment-details-container">
        <div className="appointment-details-info">
          <span className="appointment-details-info-title">Schulungen</span>
          <div className="appointment-details-info-details">
            {appointment.orderItems.map((project) => (
              <span key={`${project.project.name} ${Math.random(100)}`}>{`${project.project.name} x ${project.amount} Mal`}</span>
            ))}
          </div>
        </div>
      </div>
      <div className="appointment-details-container">
        <div className="appointment-details-info">
          <span className="appointment-details-info-title">Meine Referentin</span>
          <div className="appointment-details-info-details">
            <span>{`${appointment.trainer.firstName} ${appointment.trainer.lastName}`}</span>
            <span>{`Team ${appointment.trainer.teamName}`}</span>
            <span>{appointment.trainer.phone}</span>
          </div>
        </div>
      </div>
    </div>
  );
};
  
export default AppointmentDetail;
  